export var dateFormat = 'DD-MM-YYYY';
export var dateFormat2 = 'YYYY-MM-DD';
export var montFormat = 'MM-YYYY';
export var timeFormat = 'HH:mm:ss';
export var dateTimeFormat = "".concat(dateFormat, " ").concat(timeFormat);
export var daysOfWeek = {
  monday: 'monday',
  tuesday: 'tuesday',
  wednesday: 'wednesday',
  thursday: 'thursday',
  friday: 'friday',
  saturday: 'saturday',
  sunday: 'sunday'
};